<template>
  <div class="popover-menu-card" :class="[`popover-menu-card--size-${size}`]">
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'PopoverMenuCard',

  props: {
    size: {
      type: String as PropType<'normal' | 'fit-content'>,
      default: () => 'normal',
    },
  },
});
</script>

<style lang="scss">
@use 'settings/colors';
@use 'settings/settings';
.popover-menu-card {
  background-color: colors.$color-white;
  border-radius: settings.$border-radius;
  box-shadow: settings.$box-shadow-border-grey-30, settings.$box-shadow-layer-2;
  width: 264px;

  // TODO: should not be in the card
  font-size: 14px;
  line-height: 1.1;

  &:focus {
    outline: none;
  }
}

.popover-menu-card--size-normal {
  width: 264px;
}

.popover-menu-card--size-fit-content {
  width: fit-content;
}
</style>
